// extracted by mini-css-extract-plugin
export var questionBox = "_74-0";